const shipping = {
    free_shipping: 'Consegna Gratuita',
    standard_shipping: 'Consegna Standard',
    express_shipping: 'Consegna Express',
    free_shipping_desc: 'Per ordini superiori a €50 - 3-5 giorni lavorativi. Disponibile solo in Olanda.',
    standard_shipping_desc: '3-5 giorni lavorativi. Disponibile solo in Olanda.',
    express_shipping_desc: '1-2 giorni lavorativi. Disponibile solo in Olanda.',
    netherlands_only: 'Disponibile solo in Olanda'
};

export default shipping;
